export default function Gadgets(){
    return(
        <div>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                        <h1 className="titulo text-center">
                            ARSENAL
                        </h1>
                    </div>
                </div>
            </div>

            <hr></hr>

            <div className="container gadgets">
                <div className="row gy-5">
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4">
                        <div class="card bg-dark h-100">
                            <img src="/imagenes/batimovil.jpg" class="card-img-top" alt="batimovil"></img>
                                <div class="card-body">
                                    <h5 class="titulo card-title">BATMÓVIL</h5>
                                    <hr className="gold w-50"></hr>
                                    <p class="card-text text-white">
                                        Vehículo acorazado equipado con armas y sistemas 
                                        avanzados.
                                    </p>
                                </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4">
                        <div class="card bg-dark h-100">
                            <img src="/imagenes/batarang.jpg" class="card-img-top" alt="batarang"></img>
                                <div class="card-body">
                                    <h5 class="titulo card-title">BATARANG</h5>
                                    <hr className="gold w-50"></hr>
                                    <p class="card-text text-white">
                                        Arma arrojadiza en forma de murciélago.
                                    </p>
                                </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4">
                        <div class="card bg-dark h-100">
                            <img src="/imagenes/baticinturon.jpg" class="card-img-top" alt="baticinturon"></img>
                                <div class="card-body">
                                    <h5 class="titulo card-title">BATICINTURÓN</h5>
                                    <hr className="gold w-50"></hr>
                                    <p class="card-text text-white">
                                        Cinturón lleno de herramientas útiles.
                                    </p>
                                </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4">
                        <div class="card h-100 bg-dark">
                            <img src="/imagenes/bomba-humo.jpg" class="card-img-top" alt="bomba-humo"></img>
                                <div class="card-body">
                                    <h5 class="titulo card-title">BOMBAS DE HUMO</h5>
                                    <hr className="gold w-50"></hr>
                                    <p class="card-text text-white">
                                        Pequeño dispositivo que libera una nube de humo para 
                                        distraer a los enemigos o escapar sin ser visto.
                                    </p>
                                </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4">
                        <div class="card h-100 bg-dark">
                            <img src="/imagenes/batclaw.jpg" class="card-img-top" alt="batclaw"></img>
                                <div class="card-body">
                                    <h5 class="titulo card-title">BATCLAW</h5>
                                    <hr className="gold w-50"></hr>
                                    <p class="card-text text-white">
                                        Dispositivo similar a una garra que sirve para 
                                        atraer objetos, abrir conductos o interactuar 
                                        con mecanismos a distancia.
                                    </p>
                                </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4">
                        <div class="card h-100 bg-dark">
                            <img src="/imagenes/batgrapnel.jpg" class="card-img-top" alt="batgrapnel"></img>
                                <div class="card-body">
                                    <h5 class="titulo card-title">BATGRAPNEL</h5>
                                    <hr className="gold w-50"></hr>
                                    <p class="card-text text-white">
                                        Dispositivo que le ayuda a Batman a moverse 
                                        sobre edificios y llegar a lugares altos.
                                    </p>
                                </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4">
                        <div class="card h-100 bg-dark">
                            <img src="/imagenes/explosive_gel.jpg" class="card-img-top" alt="explosive-gel"></img>
                                <div class="card-body">
                                    <h5 class="titulo card-title">GEL EXPLOSIVO</h5>
                                    <hr className="gold w-50"></hr>
                                    <p class="card-text text-white">
                                        Un dispositivo que sirve para destruir paredes 
                                        débiles o abrir caminos si es necesario.
                                    </p>
                                </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4">
                        <div class="card h-100 bg-dark">
                            <img src="/imagenes/batcomputer.jpg" class="card-img-top" alt="batcomputer"></img>
                                <div class="card-body">
                                    <h5 class="titulo card-title">BATCOMPUTER</h5>
                                    <hr className="gold w-50"></hr>
                                    <p class="card-text text-white">
                                        Computadora avanzada que sirve para rastrear 
                                        criminales, analizar evidencias y planear 
                                        estrategias.
                                    </p>
                                </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xl-4">
                        <div class="card h-100 bg-dark">
                            <img src="/imagenes/bat-signal.jpg" class="card-img-top" alt="bat-signal"></img>
                                <div class="card-body">
                                    <h5 class="titulo card-title">BATSEÑAL</h5>
                                    <hr className="gold w-50"></hr>
                                    <p class="card-text text-white">
                                        No es un gadget como tal, pero es una herramienta 
                                        que le sirve a Batman para comunicarse con la 
                                        policía cuando hay problemas.
                                    </p>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}